window.VH = window.VH === undefined ? {} : window.VH;
VH.AjaxForm = {
    // todo: добавить возможность обновлять связанные списки.
    init : function init() {
        console.log(['VH.AjaxForm']);

        VH.Helper.b.on('submit', '.ajaxForm', function (e) {
            let f = $(this),
                loader = VH.Helper.showLoader(f.parent());
            console.log([this, new FormData(this), arguments]);
            $.ajax({
                type: "POST",
                url: f.attr('action'),
                data: (e.originalEvent === undefined ? new FormData(this) : new FormData(this, e.originalEvent.submitter)),
                processData: false,
                contentType: false,
                success: function (result) {
                    console.log(['success', result]);
                    if ($(result).attr('id') === 'ais-alert-success') {
                        f.closest('#ajaxModal').modal('hide');
                    } else {
                        f.parent().html(result);
                    }
                    if (f.data('ajax-form-reload')) {
                        let items = f.data('ajax-form-reload');
                        for (let i in items) {
                            VH.AjaxLoad.load(items[i]);
                        }
                    }
                },
                error : function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status >= 400) {
                        f.parent().html('<div class="alert alert-danger">' + jqXHR.responseText + '</div>');
                        VH.Helper.hideLoader(loader);
                    }
                }
            });
            return false;
        });
    }
};